export enum ResourceType {
  Binary = 'Binary',
  Bundle = 'Bundle',
  ClaimResponse = 'ClaimResponse',
  DeviceRequest = 'DeviceRequest',
  DocumentReference = 'DocumentReference',
  Endpoint = 'Endpoint',
  Library = 'Library',
  Location = 'Location',
  NutritionOrder = 'NutritionOrder',
  OperationOutcome = 'OperationOutcome',
  Organization = 'Organization',
  Patient = 'Patient',
  Parameters = 'Parameters',
  Practitioner = 'Practitioner',
  PractitionerRole = 'PractitionerRole',
  Questionnaire = 'Questionnaire',
  QuestionnaireResponse = 'QuestionnaireResponse',
  ServiceRequest = 'ServiceRequest',
  Task = 'Task',
  ValueSet = 'ValueSet',
  VisionPrescription = 'VisionPrescription',
}
